import { connect } from 'react-redux'
import { PuzzlePage } from '../components'

const mapStateToProps = (state, ownProps) => {
  return ({
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PuzzlePage)


// WEBPACK FOOTER //
// ./src/Pages/User/containers/PuzzlePage.js